import useSellerTheme from '@seller-hermes/hooks/useSellerTheme';
import { Helmet } from 'react-helmet';
import { useStoreState } from '@seller-hermes/hooks/easy-peasy';
import { defaultTheme } from '@seller-hermes/hooks/useSellerTheme/use-seller-theme';
import { router } from './globals';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const loadingFavicon = '/images/loading.ico';

const Headers = () => {
  const { carrier_name, favicon } = useSellerTheme();
  const { i18n } = useTranslation();
  const isLoading = useStoreState((s) => s.login.sellerGroupUser.isLoading);
  const isLogged = useStoreState((s) => s.login.isLogged);

  return isLogged ? (
    <Helmet>
      <html lang={i18n.language} />
      <title>{isLoading ? 'Carregando' : `Dashboard | ${carrier_name}`}</title>
      <link
        rel="icon"
        href={isLoading ? loadingFavicon : favicon || defaultTheme.favicon}
      />
    </Helmet>
  ) : (
    <Helmet>
      <html lang={i18n.language} />
      <link rel="icon" href={defaultTheme.favicon} />
    </Helmet>
  );
};

export default Headers;
